import {
  measureActivitySelectionListRenderPerformance,
  measureFirstItineraryRenderPerformance,
  measureHotelSelectionListRenderPerformance,
} from '@libs/utils';

import { getMetrics } from '../metrics/metrics';

import { logStatsigEvent } from './statsigConfiguration';

const enum GrafanaEventType {
  // Initialization Performance
  PerformancePageLoaded = 'performance_page_loaded',
  PerformanceAppInitiated = 'performance_app_initiated',
  // Itinerary Performance
  PerformanceTripOverviewPageRendered = 'trip_overview_page_rendered',
  PerformanceItineraryRequested = 'performance_itinerary_requested',
  PerformanceItineraryReceived = 'performance_itinerary_received',
  PerformanceItineraryRendered = 'performance_itinerary_rendered',
  PerformanceItineraryTotalTimeToRender = 'performance_itinerary_total_time_to_render',
  // Hotel List Performance
  PerformanceHotelListRequested = 'performance_hotel_list_requested',
  PerformanceHotelListReceived = 'performance_hotel_list_received',
  PerformanceHotelListRendered = 'performance_hotel_list_rendered',
  PerformanceHotelListTotalTimeToRender = 'performance_hotel_list_total_time_to_render',
  // Activity List Performance
  PerformanceActivityListRequested = 'performance_activity_list_requested',
  PerformanceActivityListReceived = 'performance_activity_list_received',
  PerformanceActivityListRendered = 'performance_activity_list_rendered',
  PerformanceActivityListTotalTimeToRender = 'performance_activity_list_total_time_to_render',
  // Network Errors
  GraphQLRetriesStarted = 'graphql_retries_started',
  GraphQLRetriesFailed = 'graphql_retries_failed',
  ItineraryHotelStaticInfoRetriesStarted = 'itinerary_hotel_static_info_retries_started',
  ItineraryHotelStaticInfoRetriesSucceeded = 'itinerary_hotel_static_info_retries_succeeded',
  ItineraryTransportStaticInfoRetriesStarted = 'itinerary_transport_static_info_retries_started',
  ItineraryTransportStaticInfoRetriesSucceeded = 'itinerary_transport_static_info_retries_succeeded',
}

const metrics = getMetrics();
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const HISTOGRAM_THRESHOLDS = [50, 100, 200, 400, 800, 1600, 3200, 6400, 12800];

export function trackPerformancePageLoaded(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformancePageLoaded,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceAppInitiated(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceAppInitiated,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceTripOverviewPageRendered(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceTripOverviewPageRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryRequested(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceItineraryRequested,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryReceived(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceItineraryReceived,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryRendered(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceItineraryRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceItineraryTotalTimeToRender(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceItineraryTotalTimeToRender,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListRequested(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceHotelListRequested,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListReceived(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceHotelListReceived,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListRendered(timeToEvent: number): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceHotelListRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceHotelListTotalTimeToRender(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceHotelListTotalTimeToRender,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListRequested(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceActivityListRequested,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListReceived(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceActivityListReceived,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListRendered(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceActivityListRendered,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackPerformanceActivityListTotalTimeToRender(
  timeToEvent: number
): void {
  const histogram = metrics.getHistogram(
    GrafanaEventType.PerformanceActivityListTotalTimeToRender,
    HISTOGRAM_THRESHOLDS
  );
  histogram.observe({}, timeToEvent);
}

export function trackGraphQLRetriesStarted(): void {
  const counter = metrics.getCounter(GrafanaEventType.GraphQLRetriesStarted);
  counter.inc({});
}

export function trackGraphQLRetriesFailed(): void {
  const counter = metrics.getCounter(GrafanaEventType.GraphQLRetriesFailed);
  counter.inc({});
}

export function trackItineraryHotelStaticInfoRetriesStarted(): void {
  const counter = metrics.getCounter(
    GrafanaEventType.ItineraryHotelStaticInfoRetriesStarted
  );
  counter.inc({});
}

export function trackItineraryHotelStaticInfoRetriesSucceeded(): void {
  const counter = metrics.getCounter(
    GrafanaEventType.ItineraryHotelStaticInfoRetriesSucceeded
  );
  counter.inc({});
}

export function trackItineraryTransportStaticInfoRetriesStarted(): void {
  const counter = metrics.getCounter(
    GrafanaEventType.ItineraryTransportStaticInfoRetriesStarted
  );
  counter.inc({});
}

export function trackItineraryTransportStaticInfoRetriesSucceeded(): void {
  const counter = metrics.getCounter(
    GrafanaEventType.ItineraryTransportStaticInfoRetriesSucceeded
  );
  counter.inc({});
}

const enum DeserializeFlowEventType {
  DeserializeHotelWithOldIngredientPrefix = 'deserialize_hotel_with_old_ingredient_prefix',
  DeserializeHotelWithoutHotelFiltersPrefix = 'deserialize_hotel_without_hotel_filters_prefix',
  DeserializeHotelWithoutSuggestionOrderPrefix = 'deserialize_hotel_without_suggestion_order_prefix',
  DeserializeHotelWithOldRoomPrefix = 'deserialize_hotel_with_old_room_prefix',
  DeserializeHotelWithoutBoardBasisPrefix = 'deserialize_hotel_without_board_basis_prefix',
  DeserializeHotelWithoutRoomTypeId = 'deserialize_hotel_without_room_type_id',
  DeserializeStayWithoutSelectionPrefix = 'deserialize_stay_without_selection_prefix',
  DeserializeTransportWithoutSuggestionOrderPrefix = 'deserialize_transport_without_suggestion_order_prefix',
  DeserializeActivityWithSupplierToken = 'deserialize_activity_with_supplier_token',
}

interface UrlMetadata extends Record<string, string> {
  url: string;
  referrer: string;
}

export function getUrlMetadata(): UrlMetadata {
  return {
    url: window.location.href,
    referrer: document.referrer,
  };
}

export function trackDeserializeHotelWithOldIngredientPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldIngredientPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutHotelFiltersPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutHotelFiltersPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutSuggestionOrderPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithOldRoomPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldRoomPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutBoardBasisPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutBoardBasisPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutRoomTypeId(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutRoomTypeId,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeStayWithoutSelectionPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeStayWithoutSelectionPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeTransportWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeTransportWithoutSuggestionOrderPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeActivityWithSupplierToken(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeActivityWithSupplierToken,
    undefined,
    getUrlMetadata()
  );
}

export function trackFallbackStaticInfoReceived(
  constraintSelection: string
): void {
  logStatsigEvent(
    'telemetry_fallback_static_info_received',
    constraintSelection
  );
}

export function trackPerformance(): void {
  measureFirstItineraryRenderPerformance().then((measures) => {
    const {
      timeToTripOverviewPageRendered,
      timeToFirstItineraryAvailabilityRequestMs,
      timeToFirstItineraryAvailabilityReceivedMs,
      timeToFirstItineraryRenderedMs,
      totalTimeRequiredToRenderFirstItinerary,
    } = measures;

    trackPerformanceTripOverviewPageRendered(timeToTripOverviewPageRendered);
    trackPerformanceItineraryRequested(
      timeToFirstItineraryAvailabilityRequestMs
    );
    trackPerformanceItineraryReceived(
      timeToFirstItineraryAvailabilityReceivedMs
    );
    trackPerformanceItineraryRendered(timeToFirstItineraryRenderedMs);
    trackPerformanceItineraryTotalTimeToRender(
      totalTimeRequiredToRenderFirstItinerary
    );
  });

  measureHotelSelectionListRenderPerformance().then(
    ({
      timeToHotelSelectionViewAvailabilityRequestMs,
      timeToHotelSelectionViewAvailabilityReceivedMs,
      timeToHotelSelectionListRenderedMs,
      totalTimeRequiredToRenderHotelSelectionList,
    }) => {
      trackPerformanceHotelListRequested(
        timeToHotelSelectionViewAvailabilityRequestMs
      );
      trackPerformanceHotelListReceived(
        timeToHotelSelectionViewAvailabilityReceivedMs
      );
      trackPerformanceHotelListRendered(timeToHotelSelectionListRenderedMs);
      trackPerformanceHotelListTotalTimeToRender(
        totalTimeRequiredToRenderHotelSelectionList
      );
    }
  );

  measureActivitySelectionListRenderPerformance().then(
    ({
      timeToActivitySelectionViewAvailabilityRequestMs,
      timeToActivitySelectionViewAvailabilityReceivedMs,
      timeToActivitySelectionListRenderedMs,
      totalTimeRequiredToRenderActivitySelectionList,
    }) => {
      trackPerformanceActivityListRequested(
        timeToActivitySelectionViewAvailabilityRequestMs
      );
      trackPerformanceActivityListReceived(
        timeToActivitySelectionViewAvailabilityReceivedMs
      );
      trackPerformanceActivityListRendered(
        timeToActivitySelectionListRenderedMs
      );
      trackPerformanceActivityListTotalTimeToRender(
        totalTimeRequiredToRenderActivitySelectionList
      );
    }
  );
}
